import type { FC } from 'react';
import type { IGatsbyImageData } from 'gatsby-plugin-image';
import { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Flex, Stack } from '@chakra-ui/react';

const FooterExtra: FC = () => {
  const data = useStaticQuery(graphql`
    query GetFooterExtraImages {
      allFile(filter: { sourceInstanceName: { eq: "images" }, relativeDirectory: { eq: "footer/extra" } }) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(height: 50)
            }
          }
        }
      }
    }
  `);

  const items: { image: IGatsbyImageData; alt: string }[] = useMemo(() => {
    return data.allFile.edges.map(({ node }: { node: Queries.File }) => ({
      image: node.childImageSharp?.gatsbyImageData,
      alt: node.name,
    }));
  }, []);

  if (!items.length) {
    return null;
  }

  return (
    <Stack>
      <Flex as='ul' p={0} gap={4} flexWrap='wrap' direction='row-reverse' justifyContent='center'>
        {items.map(({ image, alt }, index) => (
          <Flex key={index} as='li' listStyleType='none'>
            <GatsbyImage image={image!} alt={alt} />
          </Flex>
        ))}
      </Flex>
      <Flex as='small' justifyContent='center'>
        All rights to the game Mines Dare 2 Win belong to Hacksaw Gaming. For individuals aged 18 and over only. Terms
        and conditions apply.
      </Flex>
    </Stack>
  );
};

export default FooterExtra;
